(function(api) {
	
	api.GetDomList = GetDomList;
	api.GetSkolaList = GetSkolaList;
	api.GetSmjerList = GetSmjerList;
	api.PrijavaUpisi = PrijavaUpisi;
	api.GetRezervacije = GetRezervacije;
	api.GetPaviljonZaRezervacije = GetPaviljonZaRezervacije;
	api.GetKatZaRezervacije = GetKatZaRezervacije;
	
	api.ObrisiRezervaciju = ObrisiRezervaciju;
	api.RezervirajSobu = RezervirajSobu;
	api.PotvrdiRezervacijuSobe = PotvrdiRezervacijuSobe;
	api.DajBankuIzIBana = DajBankuIzIBana;	
	
	api.GetZadPredlSFields = GetZadPredlSFields;	
	api.GetZaduznicaSFields = GetZaduznicaSFields;
	api.ZaduznicaSIzPredloska = ZaduznicaSIzPredloska;	
	api.SuglasanUZaduznicaS = SuglasanUZaduznicaS;	
	api.SuglasanUZaduznicaSStavku = SuglasanUZaduznicaSStavku;	
	api.SuglasanIzZaduznicaS = SuglasanIzZaduznicaS;	
	api.GetZadNapFields = GetZadNapFields;
	api.PripremaNaDanUZaduznica = PripremaNaDanUZaduznica;
	api.GetStudentID = GetStudentID;
	api.GetZaduznicaZaStudenta = GetZaduznicaZaStudenta;
	api.GetZaduznicaNapomena = GetZaduznicaNapomena;
	api.GetZaSuglasnostStavaka = GetZaSuglasnostStavaka;
	api.ProvjeriZadStudenta = ProvjeriZadStudenta;
	api.SuglasanUZaduznicu = SuglasanUZaduznicu;
	api.ZaduznicaPotpisujem = ZaduznicaPotpisujem;
	api.ZaduznicaJePotpisana = ZaduznicaJePotpisana;
	api.ZaduznicaOtkljucaj = ZaduznicaOtkljucaj;
	api.ZaduznicaSUskladiStavke = ZaduznicaSUskladiStavke;
	api.ZaduznicaSObrisi = ZaduznicaSObrisi;
	api.ZaduznicaSKolicinaIzPredloska = ZaduznicaSKolicinaIzPredloska;
	
	function ObrisiRezervaciju() {
		return $.dsDirectCall({ 
			method: "sd/ObrisiRezervaciju"
		});
	}
	
	function RezervirajSobu() {
		return $.dsDirectCall({ 
			method: "sd/RezervirajSobu"
		});
	}

	function PotvrdiRezervacijuSobe(kod) {
		return $.dsDirectCall({ 
			method: "sd/PotvrdiRezervacijuSobe",
			params: [kod]
		});
	}
	
	function GetDomList (natjecaj) {
		return $.dsDirectCall({ 
			method: "sd/GetDomList", 
			params: [natjecaj]
		});
	}
	
	function GetSkolaList (natjecaj) {
		return $.dsDirectCall({ 
			method: "sd/GetSkolaList", 
			params: [natjecaj]
		});
	}
		
	function GetSmjerList (skola) {
		return $.dsDirectCall({ 
			method: "sd/GetSmjerList", 
			params: [skola]
		});
	}
	
	function PrijavaUpisi(data, errorCB, doneCB, override) {
		var dodatak = '';
		if (override)
			dodatak = '/true';
			
		return $.ajax({
	        url: kontorouter.getModulPath('prijava/spremi')+dodatak,
	        type: "POST",
	        data: data,
	        dataType: "json",
	    })
	    .error(errorCB)
	    .done(doneCB);
	}

	function GetRezervacije (paviljon, kat) {
		return $.dsDirectCall({ 
			method: "sd/GetRezervacije", 
			params: [paviljon, kat]
		});
	}	
	
	function GetPaviljonZaRezervacije() {
		return $.dsDirectCall({ 
			method: "sd/GetPaviljonZaRezervacije"
		});
	}

	function GetKatZaRezervacije(paviljon) {
		return $.dsDirectCall({ 
			method: "sd/GetKatZaRezervacije",
			params: [paviljon]
		});
	}

	function DajBankuIzIBana(iban) {
		return $.dsDirectCall({ 
			method: "sd/DajBankuIzIBana",
			params: [iban]
		});
	}
	
	function GetZadPredlSFields() {
	    return $.dsDirectCall({ 
			method: "sd/GetZadPredlSFields" 
	    });
	}
	
	function GetZaduznicaSFields(zaduznica, vrsta) {
		    return $.dsDirectCall({ 
				method: "sd/GetZaduznicaSFields", 
				params: [zaduznica, vrsta]
		    });
		}	
		
	function ZaduznicaSIzPredloska(zaduznica){
			return $.dsDirectCall({
				method: "sd/ZaduznicaSIzPredloska",
				params: [zaduznica]
			});
		}
	
	function SuglasanUZaduznicaS(zaduznica){
			return $.dsDirectCall({
				method: "sd/SuglasanUZaduznicaS",
				params: [zaduznica]
			});
		}
			
	function SuglasanUZaduznicaSStavku(zaduznicas, suglasan){
			return $.dsDirectCall({
				method: "sd/SuglasanUZaduznicaSStavku",
				params: [zaduznicas, suglasan]
			});
		}

	function SuglasanIzZaduznicaS(zaduznica){
			return $.dsDirectCall({
				method: "sd/SuglasanIzZaduznicaS",
				params: [zaduznica]
			});
		}
		
	function GetZadNapFields(zaduznica, vrsta) {
		return $.dsDirectCall({ 
				method: "sd/GetZadNapFields", 
				params: [zaduznica, vrsta]
			});
		}
		
	function PripremaNaDanUZaduznica(zaduznica) {
			return $.dsDirectCall({ 
					method: "sd/PripremaNaDanUZaduznica", 
					params: [zaduznica]
				});
		}
	
	function GetStudentID() {
			return $.dsDirectCall({ 
					method: "sd/GetStudentID",
					params: [] 
				});
		}
		
	function GetZaduznicaZaStudenta(studentid) {
			return $.dsDirectCall({ 
					method: "sd/GetZaduznicaZaStudenta", 
					params: [studentid]
			});
		}

	function GetZaduznicaNapomena(zaduznica, vrstanapomene) {
			return $.dsDirectCall({ 
					method: "sd/GetZaduznicaNapomena", 
					params: [zaduznica, vrstanapomene]
			});
		}
		
	function GetZaSuglasnostStavaka(zaduznica) {
			return $.dsDirectCall({ 
					method: "sd/GetSuglasanStavaka", 
					params: [zaduznica]
			});
		}

	function ProvjeriZadStudenta(studentid) {
			return $.dsDirectCall({ 
					method: "sd/ProvjeriZadStudenta", 
					params: [studentid]
			});
		}
						
	function SuglasanUZaduznicu(zaduznica) {
			return $.dsDirectCall({ 
					method: "sd/SuglasanUZaduznicu", 
					params: [zaduznica]
			});
		}

	function ZaduznicaPotpisujem(zaduznica) {
			return $.dsDirectCall({ 
					method: "sd/ZaduznicaPotpisujem", 
					params: [zaduznica]
			});
		}		
				
	function ZaduznicaJePotpisana(zaduznica) {
			return $.dsDirectCall({ 
					method: "sd/ZaduznicaJePotpisana", 
					params: [zaduznica]
			});
		}
		
		
	function ZaduznicaOtkljucaj(zaduznica) {
			return $.dsDirectCall({ 
					method: "sd/ZaduznicaOtkljucaj", 
					params: [zaduznica]
			});
		}		

	function ZaduznicaSUskladiStavke(zaduznica) {
			return $.dsDirectCall({ 
					method: "sd/ZaduznicaSUskladiStavke", 
					params: [zaduznica]
			});
		}
		
	function ZaduznicaSObrisi(zaduznicas) {
			return $.dsDirectCall({ 
					method: "sd/ZaduznicaSObrisi", 
					params: [zaduznicas]
			});
		}
		
	function ZaduznicaSKolicinaIzPredloska(zaduznicas, zadinventar) {
			return $.dsDirectCall({ 
					method: "sd/ZaduznicaSKolicinaIzPredloska", 
					params: [zaduznicas, zadinventar]
			});
		}

		
} (konto.sd.api = {}));